/**
 * Slider
 */
import {lory} from 'lory.js';
export default {
  init() {
    this.$element = document.querySelector('.js-slider');
    if (!(this.$element instanceof HTMLElement)) return;
    this.$thumbNavigationContainer = this.$element.querySelector('.js-slider-nav');
    this.keyUpListener = this.triggerKeyboardSlideChange.bind(this);
    this.slideCount = this.$element.querySelectorAll('.c-slider__slide').length;

    this.attachListeners();
  },

 attachListeners() {
    // Only have keyboard event listeners on focus element
    this.$element.addEventListener('focus', () => document.addEventListener('keyup', this.keyUpListener), true);
    this.$element.addEventListener('blur', () => document.removeEventListener('keyup', this.keyUpListener), true);

    if (this.$thumbNavigationContainer) {
      this.$element.addEventListener('after.lory.init', this.initThumbNavigationEvents.bind(this));
      this.$element.addEventListener('after.lory.slide', this.toggleThumbNavigationActiveClass.bind(this));
      this.$element.addEventListener('on.lory.resize', this.resetThumbNavigationActiveClass.bind(this));
    }
    // Only create the instance when the CSS is applied otherwise the width of the frame is incorrect
    if (document.readyState === "complete" || document.readyState === "loaded" || document.readyState === "interactive") {
      this.loryInit();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        this.loryInit();
      });
    }
  },

  loryInit() {
    this.instance = lory(this.$element, {
      slideSpeed: 500,
      enableMouseEvents: true,
      infinite: 1,
      classNameFrame: 'c-slider__frame',
      classNameSlideContainer: 'c-slider__slides',
      classNamePrevCtrl: 'c-slider__prev',
      classNameNextCtrl: 'c-slider__next',
    });
  },

  /**
   * Init thumb Navigation items
   *
   * Add the click event listeners to the created items
   * @param {Event} e
   */
  initThumbNavigationEvents() {
    for (let i = 0; i < this.slideCount; i++) {
      this.$thumbNavigationContainer.children[i].addEventListener('click', (e) => {
        this.instance.slideTo(parseInt(e.currentTarget.getAttribute('data-slide')));
        e.preventDefault();
      });
    }
  },

  /**
   * Toggle thumb Navigation Active Class
   *
   * @param {Event} e
   */
  toggleThumbNavigationActiveClass(e) {
    for (let i = 0; i < this.slideCount; i++) {
      this.$thumbNavigationContainer.children[i].classList.remove('is-active');
    }
    this.$thumbNavigationContainer.children[e.detail.currentSlide - 1].classList.add('is-active');
  },

  /**
   * Reset thumb Navigation Active Class
   *
   * @param {Event} e
   */
  resetThumbNavigationActiveClass() {
    for (let i = 0; i < this.slideCount; i++) {
      this.$thumbNavigationContainer.children[i].classList.remove('is-active');
    }
    this.$thumbNavigationContainer.children[0].classList.add('is-active');
  },

  /**
   * Trigger Keyboard Slide Change
   *
   * Move a slide forward on keypress right arrow
   * Move a slide backward on keypress left arrow
   * @param {Event} event
   */
  triggerKeyboardSlideChange(event) {
    // left arrow
    if (event.keyCode == '37') {
      this.instance.prev();
      return;
    }
    // right arrow
    if (event.keyCode == '39') {
      this.instance.next();
      return;
    }
  },
}
